import classnames from 'classnames';
import LogoEnSvg from "./LogoEnSvg";
import LogoEsSvg from "./LogoEsSvg";
import { getLanguage } from '@cmsgov/design-system';
import { jsx as _jsx } from "preact/compat/jsx-runtime";
export function Logo(props) {
  return /*#__PURE__*/_jsx("span", {
    className: classnames('hc-c-logo', props.className),
    children: getLanguage() === 'es' ? /*#__PURE__*/_jsx(LogoEsSvg, {
      titleId: props.titleId
    }) : /*#__PURE__*/_jsx(LogoEnSvg, {
      titleId: props.titleId
    })
  });
}
export default Logo;